module.exports = __webpack_public_path__ + "static/media/spades.dff4e060.svg";